import React, { useState } from "react";
import { IconType } from "react-icons";
import { PiNotePencilBold } from "react-icons/pi";
import { MdCall, MdOutlineTextsms } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { RxCalendar } from "react-icons/rx";
import { FaPen, FaSms } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import { FormikProps } from "formik";
import ActivitiesWrapper from "./Activities/ActivitiesWrapper";
import EditNewInquiryFormWrapper from "../Edit/EditNewInquiryFormWrapper";
import { showToast } from "src/utils/showToaster";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import AddSummryDialogWrapper from "./SummaryDialog/AddSummryDialogWrapper";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import moment from "moment";
import { GrTasks } from "react-icons/gr";
import { Tooltip } from "@mui/material";
import AddTaskFormDialogWrapper from "./AddTaskDialog/AddTaskFormDialogWrapper";
import ATMMarkdownContainer from "src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer";
import { ATMShowField } from "./Activities/Tabs/TaskTab/TaskTabList";
import { FiPhoneCall } from "react-icons/fi";
import { AiOutlineMail } from "react-icons/ai";
import { SiGotomeeting } from "react-icons/si";
import { IoMdAddCircleOutline } from "react-icons/io";
import AddLifeCycleStageFormWrapper from "./AddLifeCycleStage/AddLifeCycleStageFormWrapper";
import { useNavigate } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";

type tabIcon = {
  Icon: IconType;
  label: string;
  onClick: any;
};

type Props = {
  formikProps: FormikProps<any>;
  editorValue?: string;
  lifeCycleStageOptions: any;
  actionDataIsLoading: boolean;
  queryData: any;
  InquiryId: any;
  isLoadingUpdateAction: boolean;
  updateQuery: any;
  followUpData: any;
  updateQueryFollowUp: any;
};

const TabIcon = ({ Icon, label, onClick }: tabIcon) => {
  return (
    <Tooltip title={label} placement="top-start">
      <div className="w-[40px] text-center ">
        <div
          onClick={onClick}
          className="border cursor-pointer rounded-full bg-slate-100	  py-[7px] flex justify-center"
        >
          <Icon size="1.2em" color="#425b76" />
        </div>
        <span className="text-xs text-slate-500">{label} </span>
      </div>
    </Tooltip>
  );
};

const IconSwitch = (actionType: string) => {
  switch (actionType) {
    case "NOTE":
      return {
        name: "note",
        icon: <PiNotePencilBold size="1.2em" color="#425b76" />,
      };
    case "EMAIL":
      return {
        name: "email",
        icon: <AiOutlineMail size="1.2em" color="#425b76" />,
      };
    case "CALL":
      return {
        name: "call",
        icon: <FiPhoneCall size="1.2em" color="#425b76" />,
      };
    case "MEETING":
      return {
        name: "meeting",
        icon: <SiGotomeeting size="1.2em" color="#425b76" />,
      };
    case "SMS":
      return {
        name: "sms",
        icon: <FaSms size="1.2em" color="#425b76" />,
      };
    default:
      return {
        name: "note",
        icon: <PiNotePencilBold size="1.2em" color="#425b76" />,
      };
  }
};

const ViewNewInquiry = ({
  formikProps,
  actionDataIsLoading,
  lifeCycleStageOptions,
  editorValue,
  queryData,
  InquiryId,
  isLoadingUpdateAction,
  updateQuery,
  followUpData,
  updateQueryFollowUp,
}: Props) => { 
  const navigate = useNavigate()
  const { values, setFieldValue } = formikProps;
  const [isEditProfile, setIsEditProfile] = useState(false);
  const [isShowAboutContact, setIsShowAboutContact] = useState(true);
  const [summaryLabel, setSummaryLabel] = useState("");
  const [isOpenEditNote, setIsOpenEditNote] = useState(false);
  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false);
  const [isOpenAddLifeCycle, setIsOpenAddLifeCycle] = useState(false);
  const [selectTab, setSelectTab] = useState<"Overview" | "Activities">(
    "Overview"
  );

  return (
    <div>
      <div className="flex overflow-hidden h-screen">
        <div className="w-[380px] flex flex-col gap-5 p-4 bg-white border-r h-full">
        <div className="w-20 h-8 cursor-pointer  text-primary-dark flex gap-1 items-center border rounded-md justify-center border-primary-dark" onClick={()=>{navigate('/contact')}}>
             <IoArrowBackOutline /> Back
            </div>
          <div className="flex gap-4 items-center relative group/item hover:bg-hover px-2">
            <div className="w-[50px] h-[50px] rounded-full  bg-slate-500 text-white flex justify-center items-center text-[24px]  capitalize ">
              {queryData?.name?.[0]}
            </div>
            <div>
              <p className="text-lg text-slate-500">{queryData?.name || ""} </p>
              {/* <p className="text-sm text-slate-500">Developer</p> */}
              <p className="text-sm text-slate-500">
                {queryData?.email || ""}{" "}
              </p>
            </div>
            <div className="flex justify-end absolute right-0 invisible  group-hover/item:visible px-4 rounded">
              <span
                className="cursor-pointer hover:bg-primary-dark p-2 rounded-full hover:text-white"
                onClick={() => setIsEditProfile(true)}
              >
                <FaPen size="1.3em" />
              </span>
              {isEditProfile && (
                <EditNewInquiryFormWrapper
                  InquiryId={InquiryId}
                  queryData={queryData}
                  onClose={() => setIsEditProfile(false)}
                />
              )}
            </div>
          </div>
          <div className="flex gap-4 mx-6">
            <TabIcon
              label="Note"
              onClick={() => {
                setIsOpenEditNote(true);
                setSummaryLabel("NOTE");
              }}
              Icon={PiNotePencilBold}
            />
            <TabIcon
              label="Email"
              onClick={() => {
                setIsOpenEditNote(true);
                setSummaryLabel("EMAIL");
              }}
              Icon={MdOutlineEmail}
            />
            <TabIcon
              label="Call"
              onClick={() => {
                setIsOpenEditNote(true);
                setSummaryLabel("CALL");
              }}
              Icon={MdCall}
            />
            <TabIcon
              label="Meetings"
              onClick={() => {
                setIsOpenEditNote(true);
                setSummaryLabel("MEETING");
              }}
              Icon={RxCalendar}
            />
            <TabIcon
              label="Task"
              onClick={() => {
                setIsOpenAddDialog(true);
              }}
              Icon={GrTasks}
            />
            <TabIcon
              label="SMS"
              onClick={() => {
                setIsOpenEditNote(true);
                setSummaryLabel("SMS");
              }}
              Icon={MdOutlineTextsms}
            />
          </div>
          <div className="border-t">
            <div className="flex gap-3 items-center">
              <button
                className="cursor-pointer"
                onClick={() => setIsShowAboutContact(!isShowAboutContact)}
              >
                {isShowAboutContact ? (
                  <IoIosArrowDown color="#00a4bd" />
                ) : (
                  <IoIosArrowUp color="#00a4bd" />
                )}
              </button>
              <p className="text-[14px] font-semibold">About this contact</p>
            </div>
            {isShowAboutContact ? (
              <div className="flex flex-col gap-3  mt-2">
                <div className="hover:bg-hover px-6">
                  <p className="text-gray-400  text-[12px]">Email</p>
                  <p className="text-[14px]">{queryData?.email || ""}</p>
                </div>
                <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">Phone Number</p>
                  <p className="text-[14px]">{queryData?.mobile || ""}</p>
                </div>
                {/* <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-sm">Last contacted</p>
                  <p className="text-[14px]">Tommarow </p>
                </div> */}
                <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">
                    Last FollowUp Date
                  </p>{" "}
                  <div className="text-slate-800 text-[14px]">
                    {queryData?.lastActionDate
                      ? formatedDateTimeIntoIst(
                          queryData?.lastActionDate,
                          "DD MMM yyyy"
                        )
                      : "--"}
                  </div> 
                </div>
                {/* <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">
                    Next FollowUp Date
                  </p>
                  <div className="text-slate-800 text-[14px]">
                    {queryData?.nextActionDate
                      ? formatedDateTimeIntoIst(
                          queryData?.nextActionDate,
                          "DD MMM yyyy"
                        )
                      : "--"}
                  </div>
                </div> */}
                <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">Inquired By</p>
                  <p className="text-[14px]">{queryData?.createdByName || ""} </p>
                </div>
                
                {/* LifeCycle Stage */}
                <div className="mx-6  border-b w-[330px] hover:bg-hover ">
                <span className='cursor-pointer' onClick={() => setIsOpenAddLifeCycle(true)}>
                  <IoMdAddCircleOutline size='1.2em' />
                </span>
                  <ATMSelectValue
                    labelClasses="text-gray-400 text-[12px] font-normal	"
                    extraClasses="select text-[14px]"
                    name="lifeCycleStage"
                    value={values?.lifeCycleStage}
                    onChange={(value) => {
                      setFieldValue("lifeCycleStage", value);
                      updateQuery({
                        id: InquiryId,
                        body: {
                          name: queryData?.name || " ",
                          mobile: queryData?.mobile || "",
                          email: queryData?.email || "",
                          lifecycleStage: value || "",
                        },
                      }).then((res: any) => {
                        if (res?.error) {
                          showToast("error", res?.error?.data?.message);
                        } else {
                          if (res?.data?.status) {
                            showToast("success", res?.data?.message);
                          } else {
                            showToast("error", res?.data?.message);
                          }
                        }
                      });
                    }}
                    options={lifeCycleStageOptions}
                    label="Lifecycle stage"
                  />
                </div>
                {/* <div className="mx-6  border-b w-[280px] hover:bg-hover">
                  <ATMSelectValue
                    labelClasses="!text-gray-400 !text-[12px] !font-normal"
                    extraClasses="select text-[14px]"
                    name="inquiryLabel"
                    value={values?.inquiryLabel}
                    onChange={(value) => {
                      setFieldValue("inquiryLabel", value);
                      updateQuery({
                        id: InquiryId,
                        body: {
                          name: queryData?.name || " ",
                          mobile: queryData?.mobile || "",
                          email: queryData?.email || "",
                          lifecycleStage: values?.lifeCycleStage || "",
                          inquiryLabelId: value || "",
                        },
                      }).then((res: any) => {
                        if (res?.error) {
                          showToast("error", res?.error?.data?.message);
                        } else {
                          if (res?.data?.status) {
                            showToast("success", res?.data?.message);
                          } else {
                            showToast("error", res?.data?.message);
                          }
                        }
                      });
                    }}
                    options={InquiryLabelOptions}
                    label="Inquiry status"
                    isLoading={inquiryLabelsLoading}
                  />
                </div> */} 
                 <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">Record Source</p>
                  <p className="text-[14px]">{queryData?.recordSource?.toLowerCase() || ""} </p>
                </div>

                <div className="hover:bg-hover px-6">
                  <p className="text-gray-400 text-[12px]">Last Call Summary</p>
                  <p className="text-[14px]">
                    {queryData?.lastActionSummary || ""}
                  </p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="flex-1 flex flex-col h-full overflow-scroll">
          {/* tab */}
          <div className="flex border-b  px-4">
            <button
              onClick={() => setSelectTab("Overview")}
              type="button"
              className={`${
                selectTab === "Overview"
                  ? "border-t border-x rounded font-semibold"
                  : ""
              }  p-3`}
            >
              Overview
            </button>
            <button
              onClick={() => setSelectTab("Activities")}
              type="button"
              className={`${
                selectTab === "Activities"
                  ? "border  border-b-white rounded font-semibold"
                  : ""
              }  p-3`}
            >
              Activities
            </button>
          </div>
          {selectTab !== "Activities" ? (
            <div className="flex-1 flex flex-col overflow-hidden">
              <div className="m-2 shadow-lg p-3">
                <p className="text-slate-800 font-semibold text-sm">
                  Data highlights
                </p>
                <div className="flex justify-evenly mt-2">
                  <div>
                    <p className="text-slate-800 font-semibold text-[13px]">
                      CREATE DATE
                    </p>
                    <div className="flex gap-1">
                      <div className="text-slate-800  text-[12px]">
                        {formatedDateTimeIntoIst(
                          queryData?.createdAt,
                          "MM/DD/yyyy"
                        )}
                        ,
                      </div>
                      <div className="text-[12px]  text-slate-800">
                        {formatedDateTimeIntoIst(
                          queryData?.createdAt,
                          "hh:mm A"
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="text-slate-800 font-semibold text-[13px]">
                      LIFECYCLE STAGE
                    </p>
                    <p className="text-xs">
                      {queryData?.lifecycleStage || ""}{" "}
                    </p>
                  </div>
                  <div>
                    <p className="text-slate-800 font-semibold text-[13px]">
                      LAST ACTIVITY DATE
                    </p>
                    {queryData?.lastActionDate ? (
                      <div className="flex gap-1">
                        <div className="text-slate-800  text-[12px]">
                          {formatedDateTimeIntoIst(
                            queryData?.lastActionDate,
                            "MM/DD/yyyy"
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="m-2 shadow-lg p-3  border rounded h-full overflow-hidden">
                <p className="text-slate-800 font-semibold text-sm px-2">
                  Recent activities
                </p>
                <div className="flex flex-col gap-4 h-full overflow-y-scroll">
                  {actionDataIsLoading ? (
                    Array(6)
                      .fill(0)
                      .map((_, index) => {
                        return (
                          <div key={index} className="animate-pulse  h-[95px]">
                            <div className="bg-slate-200 h-full rounded"> </div>
                          </div>
                        );
                      })
                  ) : followUpData?.length ? (
                    followUpData?.map((el: any, ind: any) => {
                      if (el?.actionType === "TASK") {
                        return (
                          <div
                            key={ind}
                            className="shadow-sm p-3 bg-slate-50 rounded-md"
                          >
                            <div className="flex justify-between border-b pb-2">
                              <div className="flex gap-1 items-center text-[14px]">
                                <IoIosArrowDown color="#00a4bd" />
                                <span className="text-slate-800 font-medium">
                                  Task
                                </span>
                                <span>assigned to</span>
                                <span>{el?.assignedToName}</span>
                              </div>
                              <div className="text-[12px] text-gray-400">
                                Created At :{" "}
                                {moment(el?.createdAt).format("DD MMM yyyy")}
                              </div>
                            </div>
                            <div className="px-4">
                              <div className="grid grid-cols-6 py-2 border-b">
                              { el?.reminderForDate && <ATMShowField
                                  value={moment(el?.reminderForDate).format(
                                    "DD MMM yyyy"
                                  )}
                                  label="Due date"
                                />}
                                <ATMShowField
                                  value={moment(el?.activityDate).format(
                                    "DD MMM yyyy"
                                  )}
                                  label="Activity Date"
                                />
                                <ATMShowField
                                  value={el?.taskName}
                                  label="Task Name"
                                />
                                <ATMShowField
                                  value={el?.queueName}
                                  label="Queue"
                                />
                                <ATMShowField
                                  value={el?.taskAction?.toLowerCase()}
                                  label="Action"
                                />
                              </div>
                              <div className="grid grid-cols-6 py-2">
                                <ATMShowField
                                  value={el?.assignedToName}
                                  label="Assigned To"
                                />
                                <ATMShowField
                                  value={el?.createdByName}
                                  label="CreatedBy"
                                />
                                <ATMShowField
                                  value={el?.priority?.toLowerCase()}
                                  label="Priority"
                                />
                                {el?.reminderOn && <ATMShowField
                                  value={el?.reminderOn?.toLowerCase()}
                                  label="ReminderOn"
                                />}
                              </div>
                              <div className="text-[13px] text-primary-dark font-medium  hover:bg-blue-50  rounded-lg p-2">
                                <ATMMarkdownContainer
                                  markdown={el?.description}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={ind}
                            className="border rounded p-2 bg-slate-50"
                          >
                            <div className="flex justify-between items-center mb-2">
                              <div className="flex gap-2 text-[13px] items-center">
                                <div className="rounded-full bg-slate-100 p-2 flex justify-center">
                                  {IconSwitch(el?.logType)?.icon}
                                </div>
                                <span className="text-slate-500">
                                  {el?.createdByName} create a{" "}
                                  <span className="font-semibold">
                                    {IconSwitch(el?.logType)?.name}{" "}
                                  </span>
                                </span>
                              </div>
                              <div className="flex items-center gap-4">
                                <div className="flex items-center text-cyan-600 text-[13px] font-semibold">
                                  Action <IoMdArrowDropdown />{" "}
                                </div>
                                <div className="flex gap-1">
                                  <div className="text-slate-400 font-medium text-[11px]">
                                    {formatedDateTimeIntoIst(
                                      el?.createdAt,
                                      "DD MMM yyyy"
                                    )}
                                    ,
                                  </div>
                                  <div className="text-[11px] font-medium text-slate-400">
                                    {formatedDateTimeIntoIst(
                                      el?.createdAt,
                                      "hh:mm A"
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="grid xl:grid-cols-6 lg:grid-cols-3 grid-cols-2 gap-4 my-3">
                              {el?.date && (
                                <ATMShowField
                                  label="Activity Date "
                                  value={formatedDateTimeIntoIst(
                                    el?.date,
                                    "DD MMM yyyy"
                                  )}
                                />
                              )}
                              {el?.time && (
                                <ATMShowField
                                  label="Activity Time"
                                  value={moment(el?.time, "HH:mm").format(
                                    "h:mm A"
                                  )}
                                />
                              )}
                                {el?.assignedToName && (
                                <ATMShowField
                                  label="Assigned To"
                                  value={el?.assignedToName?.toLowerCase()}
                                />
                              )}

                              {el?.direction && (
                                <ATMShowField
                                  label="Call Direction"
                                  value={el?.direction?.toLowerCase()}
                                />
                              )}
                              {el?.callOutcome && (
                                <ATMShowField
                                  label="Call Out Come"
                                  value={el?.callOutcome?.toLowerCase()}
                                />
                              )}
                              {el?.meetingOutcome && (
                                <ATMShowField
                                  label="Meeting OutCome"
                                  value={el?.meetingOutcome?.toLowerCase()}
                                />
                              )}
                              {el?.meetingDuration && (
                                <ATMShowField
                                  label="Meeting Duration"
                                  value={el?.meetingDuration?.toLowerCase()}
                                />
                              )}
                             {el?.reminderForDate && <ATMShowField label="Reminder Date" value={el?.reminderForDate} />}
                             {el?.reminderOn && <ATMShowField label="Reminder On" value={el?.reminderOn?.toLowerCase()} />}
                            {el?.reminderRecordSource && <ATMShowField label="Reminder Source" value={el?.reminderRecordSource?.toLowerCase()} />}
                            </div>
                            <div className="text-[13px] text-primary-dark font-medium  hover:bg-blue-50  rounded-lg p-2">
                              <ATMMarkdownContainer
                                markdown={el?.description}
                              />
                            </div>
                          </div>
                        );
                      }
                    })
                  ) : (
                    <div className="flex justify-center items-end h-[120px] text-red-700 font-medium text-lg">
                      No Data Found
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <ActivitiesWrapper  />
          )}
        </div>
      </div>
      {isOpenEditNote && (
        <AddSummryDialogWrapper
          QueryBy={summaryLabel}
          onClose={() => setIsOpenEditNote(false)}
        />
      )}
      {isOpenAddDialog && (
        <AddTaskFormDialogWrapper onClose={() => setIsOpenAddDialog(false)} />
      )}
      {isOpenAddLifeCycle && (
        <AddLifeCycleStageFormWrapper
          onClose={() => setIsOpenAddLifeCycle(false)}
        />
      )}
    </div>
  );
};

export default ViewNewInquiry;
